import React from 'react';
import PropTypes from 'prop-types';
import Clearfix from 'components/elements/clearfix';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { BaseListContainer } from 'containers/BaseContainer/BaseListContainer';
import { setMenuSelected, setMenuSelected_2 } from '@redux/actions/menuAction';
import moment from 'moment';
import { DATE_FORMAT } from 'config';
import slug from 'constants/slug';
import styled from 'styled-components';
import { COLOR } from 'config';

const NameContainer = styled.div`
  color: ${COLOR.SECOND_COLOR};
  text-decoration: underline;
`;

class FacilityDevicePanel extends React.Component {
  static propTypes = {
    facilityId: PropTypes.string.isRequired,
    hideRightHeaderContent: PropTypes.bool,
    dataList: PropTypes.array,
  };

  render() {
    const { facilityId, dataList } = this.props;

    return (
      <div style={{ width: '100%' }}>
        <Clearfix height={8} />

        <FacilityDeviceList
          dataList={dataList}
          hideRightHeaderContent
          facilityId={facilityId}
        />
      </div>
    );
  }
}

class FacilityDeviceList extends BaseListContainer {
  static propTypes = {
    facilityId: PropTypes.string,
    hideRightHeaderContent: PropTypes.bool,
  };

  constructor(props) {
    const funcApi = {};
    const columns = [
      {
        dataField: 'Name',
        text: 'Tên thiết bị',
        formatter: (cell, row) => {
          return (
            <Link
              target='_blank'
              to={slug.FACILITY_DEVICE.VIEW_WITH_ID + row._id}
              onClick={() => {
                this.props.setMenuSelected_2(null);
              }}
            >
              <NameContainer>{cell ? cell : ''}</NameContainer>
            </Link>
          );
        },
      },
      {
        dataField: 'Status',
        text: 'Tình trạng',
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
      {
        dataField: 'Location',
        text: 'Vị trí',
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
      {
        dataField: 'TechnicalSpec',
        text: 'Thông số kĩ thuật',
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
      {
        dataField: 'ProductionDate',
        text: 'Năm sản xuất',
        headerAlign: 'center',
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
      {
        dataField: 'IsCatalog',
        text: 'Catalog/ data sheet',
        headerAlign: 'center',
        formatter: (cell) => {
          return (
            <div style={{ textAlign: 'center' }}>
              {cell ? (
                <img
                  height={14}
                  alt='check-icon'
                  src='/icons/badge-check.png'
                />
              ) : (
                ''
              )}
            </div>
          );
        },
      },
      {
        dataField: 'IsCO',
        text: 'CO',
        headerAlign: 'center',
        formatter: (cell) => {
          return (
            <div style={{ textAlign: 'center' }}>
              {cell ? (
                <img
                  height={14}
                  alt='check-icon'
                  src='/icons/badge-check.png'
                />
              ) : (
                ''
              )}
            </div>
          );
        },
      },
      {
        dataField: 'IsCQ',
        text: 'CQ',
        headerAlign: 'center',
        formatter: (cell) => {
          return (
            <div style={{ textAlign: 'center' }}>
              {cell ? (
                <img
                  height={14}
                  alt='check-icon'
                  src='/icons/badge-check.png'
                />
              ) : (
                ''
              )}
            </div>
          );
        },
      },
      {
        dataField: 'LatestMaintenanceDate',
        text: 'Bảo trì bảo dưỡng gần nhất',
        formatter: (cell, row) => {
          return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
        },
      },
      {
        dataField: 'LatestRepairDate',
        text: 'Sửa chữa gần nhất',
        formatter: (cell, row) => {
          return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
        },
      },
      {
        dataField: 'LatestCalibrationDate',
        text: 'Hiệu chuẩn gần nhất',
        formatter: (cell, row) => {
          return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
        },
      },
      {
        dataField: 'LatestVerificationDate',
        text: 'Kiểm định gần nhất',
        formatter: (cell, row) => {
          return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
        },
      },
    ];

    super(
      props,
      funcApi,
      columns,
      `${slug.FACILITY_DEVICE.CREATE}?facilityId=${props.facilityId}`,
      'facilityDevice',
      null,
      false
    );

    this.state = {
      ...this.state,
      valueSearch: {
        facility: this.props.facilityId,
      },
      dataList: this.props.dataList,
      isLoading: false,
    };
  }
}

const mapStateToProps = (state) => ({
  menuStore: state.menu,
});

const mapDispatchToProps = {
  setMenuSelected,
  setMenuSelected_2,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FacilityDevicePanel)
);



// WEBPACK FOOTER //
// ./src/containers/Coso/CosoView/FacilityDevicePanel/index.js